// 報告書タイプ定数
export const REPORT_TYPE = {
  REPORT: 1,
  QR: 2
}

// 報告書タイプ名
export const REPORT_TYPE_NAME = {
  [REPORT_TYPE.REPORT]: '報告書・請求書',
  [REPORT_TYPE.QR]: '入館証QR'
}
